import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Button } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import PageWrap from "../components/PageWrap";
import PageHeader, { headerHeight } from "../components/PageHeader";
import { useStores } from "../../models";

const verifiedSuccessImg = require("../../assets/images/wallet/verifiedSucces.png");

const Body = styled.div`
  height: calc(100% - ${headerHeight});
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
  background: #fff;
`;

const Img = styled.img`
  width: 150px;
  height: 150px;
  object-fit: contain;
`;

const Title = styled.div`
  margin-top: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #000;
`;

const Tip = styled.div`
  margin-top: 12px;
  width: 80%;
  color: rgb(127, 127, 127);
  font-size: 14px;
  line-height: 1.6;
`;

const VerifiedSuccess = () => {
  const { navigate } = useNavigation();
  const { walletStore } = useStores();

  return (
    <PageWrap>
      <PageHeader title="实名认证" />
      <Body>
        <Img src={verifiedSuccessImg} alt="" />
        <Title>已认证：{walletStore.realName || ""}</Title>
        <Tip>
          为了您的交易安全，实名后不可更改请绑定实名注册的账号或卡号
        </Tip>
        <div style={{ marginTop: 20, width: "80%" }}>
          <Button
            block
            style={{ background: "rgba(0,0,0,0.8)", color: "#fff", border: 0 }}
            onClick={() => navigate("Wallet")}
          >
            认证成功
          </Button>
        </div>
      </Body>
    </PageWrap>
  );
};

export default observer(VerifiedSuccess);
